import { render, staticRenderFns } from "./homeGoods.vue?vue&type=template&id=7eddb580&"
import script from "./homeGoods.vue?vue&type=script&lang=js&"
export * from "./homeGoods.vue?vue&type=script&lang=js&"
import style0 from "./homeGoods.vue?vue&type=style&index=0&id=7eddb580&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports